import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import {AccountService} from "../../services";
import {RoleList} from "../models/roleList";

@Injectable({ providedIn: 'root' })
export class RoleService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }


    getAll() {
        return this.http.get<RoleList>(`${environment.apiEndpoint}/v1/security/roles`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }
}
